import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'
import CompanyCard from '@/components/CompanyCard'
import Vue from 'vue'

const outsourcingSlasModel = vm => ({
  title: vm.$gettext('Outsourcing SLAs'),
  endpoint: 'outsourcing-slas',
  allowNew: true,
  allowDelete: true,
  countrize: 'area_to.country',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'area_id_from',
      label: vm.$gettext('Origin Area'),
      type: 'select',
      options: 'areas',
      showKey: 'id',
      showField: 'name',
      withSelect: true,
      editable: true,
      sortable: true,
      required: true,
      description: vm.$gettext('Origin Area for this SLA'),
      default: null
    },
    {
      key: 'area_id_to',
      label: vm.$gettext('Destination Area'),
      type: 'select',
      options: 'areas',
      showKey: 'id',
      showField: 'name',
      withSelect: true,
      editable: true,
      sortable: true,
      required: true,
      description: vm.$gettext('Destination Area for this SLA'),
      default: null
    },
    {
      key: 'company_id_provider',
      label: vm.$gettext('Provider Company'),
      editable: true,
      componentEdit: (value, key, item) => {
        return {
          is: CompanyAutocomplete,
          props: {
            required: true,
            restrictTo: [['relationship', 'eq', 'provider']],
            preQuery: item.provider ? item.provider.name : null
          },
          on: {
            selected: result => {
              if (result) {
                item[key] = result.id
              } else {
                item[key] = null
              }
            }
          }
        }
      },
      formatter: (value, key, item) => {
        return item.provider
          ? new Vue({
              ...CompanyCard,
              parent: this,
              propsData: {
                company: item.provider,
                profilePicture: false,
                withTitles: false,
                withContact: false
              }
            }).$mount().$el.outerHTML
          : ''
      }
    },
    {
      key: 'sla_days',
      label: vm.$gettext('SLA Days'),
      editable: true,
      required: true,
      description: vm.$gettext('Additional days to add up to our SLA when assigning to this set'),
      type: 'number',
      step: '0.1'
    }
  ],
  filters: ['id', 'area_from.name', 'area_to.name', 'provider.name', 'provider.id'],
  includes: ['area_from', 'area_to', 'provider']
})

export default outsourcingSlasModel
